import { render, staticRenderFns } from "./InfoMessage.vue?vue&type=template&id=3230561b&"
import script from "./InfoMessage.vue?vue&type=script&lang=ts&"
export * from "./InfoMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports